import React from "react";
import ProductCard from "./ProductCard";
import ScrollReveal, { revealItemProps } from "../common/Reveal";

function ProductGrid({ products, showAddToCart = false, animate = false }) {
  if (!products.length) return null;

  if (!animate) {
    return (
      <div className="caf-product-grid">
        {products.map((product) => (
          <div key={product.id} className="min-w-0 h-full">
            <ProductCard product={product} showAddToCart={showAddToCart} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <ScrollReveal stagger className="caf-product-grid">
      {products.map((product, index) => (
        <div key={product.id} {...revealItemProps(index, "min-w-0 h-full")}>
          <ProductCard product={product} showAddToCart={showAddToCart} />
        </div>
      ))}
    </ScrollReveal>
  );
}

ProductGrid.revealManaged = true;

export default ProductGrid;
